import React from 'react';
import { useCommandPaletteIsLoaded } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import Shortcuts from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcuts/index.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

const RegisterDotShortcut = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ isLoaded }, { open }] = useCommandPaletteIsLoaded();

	return (
		<Shortcuts
			keyMap={{
				'.': {
					callback: (ev?: KeyboardEvent) => {
						fireUIAnalytics(
							createAnalyticsEvent({
								action: 'pressed',
								actionSubject: 'keyboardShortcut',
							}),
							'dotDialogKeyboardShortcut',
							{
								keyPressed: '.',
								keyboardShortcut: true,
								isLoaded,
							},
						);
						ev?.preventDefault();
						open();
					},
				},
			}}
		/>
	);
};

export default RegisterDotShortcut;
